<template>
  <div class="content">
    <p>
      {{ company }}（"The Company"）have entered into with RYODEN Corporation
      ("RYODEN") In sublicensing the use of the Service to the Customer in
      accordance with the "PESCLE Service License Agreement" ("This Agreement"),
      the Company agrees to the following points and provides the Service.
    </p>
    <ul>
      <li>
        The Company shall impose on the Customer, on its own responsibility,
        obligations equivalent to the Company's obligations set forth in This
        Agreement
      </li>
      <li>
        The granting and provision of the Services by RYODEN is solely to The
        Company, and RYODEN will not directly respond to inquiries, claims, or
        complaints from customers, and The Company will respond to such
        inquiries, claims, or complaints.
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    company: {
      type: String,
      require: true,
    },
  },
};
</script>
